<template>
    <b-container fluid>
        <b-row row wrap>
            <b-col cols="12" md="3">
                <app-form-text-input
                    placeholder="Nombre"
                    v-model="controlPoint.name"
                    :required="true"
                    @input="$v.controlPoint.name.$touch()"
                    :has-error="$v.controlPoint.name.$error"
                    error-message="Debe definir un nombre para el punto de control"
                />
            </b-col>
            <b-col cols="12" md="5">
                <app-form-text-input
                    placeholder="Descripción"
                    v-model="controlPoint.description"
                    :required="true"
                />
            </b-col>
            <b-col cols="12" md="1">
                <b-alert variant="success" v-if="positionComplete">
                    <i class="fa fa-check"></i>
                </b-alert>
                <b-alert variant="error" v-else>
                    <i class="fa fa-times"></i>
                </b-alert>
            </b-col>
            <b-col cols="12" md="3">
                <b-btn block variant="primary" @click="prepareData"
                    ><i class="fa fa-plus"></i> Agregar Punto</b-btn
                >
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import roundsRepository from "@repositories/rounds.repository";
export default {
    name: "round_control_point_form",
    props: {
        round: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        controlPoint: {
            name: "",
            description: "",
            latitude: "",
            longitude: ""
        }
    }),
    validations: {
        controlPoint: {
            name: { required }
        }
    },
    computed: {
        positionComplete() {
            return (
                !!this.controlPoint.latitude && !!this.controlPoint.longitude
            );
        }
    },
    methods: {
        prepareData() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    this.controlPoint.latitude = position.coords.latitude;
                    this.controlPoint.longitude = position.coords.longitude;
                    this.savePoint();
                });
            } else {
                toastr.error("El navegador no soporta geolocalización");
            }
        },
        async savePoint() {
            this.$v.$touch();
            if (this.$v.$invalid)
                return toastr.error(
                    "Debe diligenciar todos los campos obligatorios"
                );

            const rr = { ...roundsRepository };
            try {
                const { data } = await rr.saveControlPoint({
                    ...this.controlPoint,
                    roundId: this.round.id
                });

                if (data.status) {
                    toastr.success(
                        "Punto de control creado satisfactoriamente"
                    );
                    this.round.control_points.push(data.controlPoint);
                    this.reset();
                } else {
                    toastr.error(data.msg);
                }
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al guardar el punto de control [${err.message}]`
                );
            }
        },
        reset() {
            Object.keys(this.controlPoint).map(
                key => (this.controlPoint[key] = "")
            );
            this.$v.$reset();
        }
    },
    mounted() {}
};
</script>
